import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class ScopeResolver {
  constructor(connection) {
    this.connection = connection;
  }
  /**
   * Fetch sources registered to a scope. See
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-source-scope-list/)
   * @param {string} scopeURN
   * @param {string} elementId
   * @param {string} elementType
   * @returns {Promise.<[RegisteredScopeReferenceDto]>}
   */
  authorSourceScopeList = async ({ scopeURN, elementId, elementType }) => {
    const message = {
      type: constants.RTM_AUTHOR_SOURCE_SCOPE_LIST,
      elementId,
      elementType,
      scopeURN,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_SOURCE_SCOPE_LIST_OK,
      constants.RTM_AUTHOR_SOURCE_SCOPE_LIST_ERROR,
    );
    return response.registeredScopeReference;
  };
}

export default ScopeResolver;
